import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type FetchTaskResponse = components['schemas']['ExtendedTask'];
export type FetchTaskPath = NonNullable<paths['/executor_web/tasks/{id}']['get']['parameters']['path']>;

/** GET `/api/executor_web/v1/executor_web/tasks/{id}` — см. `paths['/executor_web/tasks/{id}']` в openapi */
export function fetchTask(path: FetchTaskPath, signal?: AbortSignal) {
	return axiosInstance.get<FetchTaskResponse>(`tasks/${path.id}`, {signal});
}
